import React, { useEffect } from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';
import CTAButton from '/src/Components/CTAButton/CTAButton';
import HelmetProvider from '/src/Components/HelmetProvider/HelmetProvider';

const ErrorPage = () => {


    // Update the page title to "What is Quoll?"
    // useEffect(() => {
    //     document.title = "Quoll - Error";
    // }, []);

    const header = "Oops! Something went wrong."
    const subHeader = "This is why we test! We're working on it and will have that error fixed soon."
    const buttonText = "Return to Home"

    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate('/');
    }

    return (
        <>
            <HelmetProvider
                pageType="error"
            />
        <div className="error-page">
            <h1>{header}</h1>
            <p>{subHeader}</p>
            <CTAButton
                onClick={handleButtonClick}
                text={buttonText}
                    category="error"
                />
            </div>
        </>
    );
};

export default ErrorPage;